<template>  
<div> <!-- root element start -->


	<div v-if="loading == '0'" class="row">
		<div class="col-12">
      <div class="card border-0">
          <div class="card-body">

            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>

          </div>
      </div>
    </div>
  </div>

  <div v-if="loading == '1'" class="row">

    <div class="col-12">
      <div class="card border-0 mb-0 pb-0">
        <div class="card-header bg-transparent border-bottom d-flex justify-content-between align-items-center">
          <span class="h5">Email Quote #{{ quoteData.id }}</span><button class="btn btn-ouline-secondary" @click="cancelEmail"><i class="fa fa-times" aria-hidden="true"></i></button>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6">
      <div class="card border-0">
        <div class="card-body">

          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Quote</span></div>
            <div class="col-12"><span class="">Reference #: {{quoteData.id}}</span></div>
            <div class="col-12"><span class="">Created: {{quoteData.created_at | moment("dddd, MMMM Do YYYY") }}</span></div>
            <div class="col-12"><span class="">Type: {{quoteData.typeName}}</span></div>
            <div class="col-12"><span class="">Creator: {{quoteData.creatorName}}</span></div>
          </div>
        </div>
      </div>

    </div>

    <div class="col-12 col-lg-6">
      <div class="card border-0">
        <div class="card-body">

          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Product</span></div>
            <div class="col-12"><span class="">{{quoteData.build.product_name}}</span></div>
          </div>


          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Build</span></div>   
            <div class="col-12"><span class="">{{quoteData.build.build_name}}</span></div>
            <div class="col-12"><span class="">{{quoteData.build.build_price | currency }}</span></div>
          </div>
        </div>
      </div>

    </div>

    <div class="col-12 col-lg-6">
      <div class="card border-0">
        <div class="card-body">

          <div class="row d-flex align-items-center mb-1">
            <div class="col-12"><span class="font-weight-bold">Message the email</span></div>
            <div class="col-12">
              <wysiwyg v-model="message" 
                wysiwygOpt
              />
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card border-0">
        <div class="card-body">

          <div class="row d-flex align-items-center mb-1">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <span class="h5 font-style-bold">Send to address</span><a v-if="emAddr.length < 3" href="#" @click="addEmAdd" class="small" >Add Address</a>
              </div>
              <div v-for="(em,index) in emAddr" class="col-12">
                <div class="input-group mb-2">
                  <div v-if="emAddr.length > 1" class="input-group-prepend">
                    <button class="btn btn-danger" type="button" @click="removeEmAddr(index)"><i class="fa fa-times" aria-hidden="true"></i></button>
                  </div>
                  <input type="email" class="form-control" placeholder="Send To Address" aria-label="Example text with button addon" v-model="emAddr[index]">
                </div>
              </div>
            </div>
          

        </div>
      </div>
    </div>
    <div class="col-12">
      <button @click="cancelEmail" class="btn btn-warning">Cancel</button>
      <button @click="submitEmail" class="btn btn-success">Send Quote</button>

    </div>
	</div>


</div> <!-- root element end -->
</template>



<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {
  hideModules: {
    "headings": true,
    "link" : true,
    "code" :true,
    "image" : true,
    "removeFormat" : true,
    "seperator": true,
    "table" : true,
  },
}); 




export default {
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      detailUrl: '/utility/user/quote/viewquoteform/',
      loading: '0',
      quoteData: [],
      message: '',
      emAddr: [],
      wysiwygOpt: {
        hideModules: { "bold": true },
      }
    }
  },
  computed: {
    
  },
  watch: {
    prop3() { this.onOpen() },
  },
  mounted() {
    this.onOpen();
  },
  methods: {
    onOpen() {
      var _this = this;
      _this.loading = '0';
      var x = _this.prop3[0];
      axios.get('/utility/user/quote/getspecificquotedetails/' + x)
        .then(function (response) {
        var a = response.data.data;
        _this.quoteData = a;
        _this.loading = '1';
        _this.emAddr.push(a.contact.contact_p_email);
        });
    },
    
    cancelEmail() {
      var _this = this;
      _this.$emit('onUComplete', ['quote-email', _this.prop3[0]])
    },
    addEmAdd() {
      var _this = this;
      if(_this.emAddr.length < 3) {
        _this.emAddr.push("");
      }
    },

    submitEmail() {
      var _this = this;
      _this.$toastr.warning('Saving Quote information.', 'Please wait!')

       var valErrors = [];

      //first remove any emAddr that are empty
      for (i = _this.emAddr.length - 1; i >= 0; --i) {
        if (_this.emAddr[i] == '' || _this.emAddr[i] == null) {
          _this.emAddr.splice(i, 1); // Remove even numbers
        }
      }

      if(_this.emAddr.length < 1 ) { valErrors.push('You must enter at least one valid email address!') }

      //validate email
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      _this.emAddr.forEach(emailValidate);
      function emailValidate(item, index) {
        if(!item.match(mailformat)) { valErrors.push("The email #"+ (index+1) +" you entered is invalid!") }
      } 

      // validate message
      if(_this.message == '' || _this.message == null || _this.message.length < 20) { valErrors.push('The message is required, and must be at least 20 characters!') }

      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 

      axios.post('/utility/user/quote/resendquote', {
        message: _this.message,
        to_add: _this.emAddr,
        quote_id: _this.prop3[0]
,      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', ['quote-email', _this.prop3[0]])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })
    },

    removeEmAddr(index){
      var _this = this;
      if(_this.emAddr.length  > 1) {
        _this.emAddr.splice(index, 1);
      } else {
        return false;
      }
    },
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },

  },    
  components:{
    ScalingSquaresSpinner,
    
  },
  filters: {

  }
}
</script>

